import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import StringHelper from '../../helpers/string.helper';
import RadioGroupProps from '../../interfaces/props/RadioGroupProps';
import { ChangeEvent } from 'react';
import classes from './RadioButtons.module.scss';

const RadioButtons = ({ label, options, onRadioChange, value, disabled, defaultValue }: RadioGroupProps) => {
  const onSelectHandler = (event: ChangeEvent<HTMLInputElement>) => {
    onRadioChange(event.target.value);
  };

  return (
    <FormControl>
      <FormLabel className={`${classes['radio-label']} mt-1`}>
        {label}
      </FormLabel>
      <RadioGroup
        row
        onChange={onSelectHandler}
        value={value}
        defaultValue={defaultValue}
      >
        {options.map((option: string) => (
          <FormControlLabel
            key={StringHelper.generateRandomString(10)}
            value={option}
            disabled={disabled}
            control={<Radio classes={{ root: classes.radio }} />}
            label={option}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButtons;
